import { getTimeZoneId } from 'src/backend/geo';

const getTimeZoneIdFromCoords = (location) => getTimeZoneId(location);

export default getTimeZoneIdFromCoords;
